import { usePageSEO } from '@/hooks/usePageSEO';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import Etapes from './components/Etapes';
import Urgence from './components/Urgence';
import BlogCards from './components/BlogCards';

export default function Merci() {
  usePageSEO({
    title: 'Merci pour votre demande | Couvreur-Lévis.com',
    description: 'Votre demande de soumission a bien été envoyée. Un couvreur partenaire vous contactera sous 2h ouvrables.',
    urlPath: '/merci',
    noindex: true,
  });

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Etapes />
        <Urgence />
        <BlogCards />
      </main>
      <Footer />
    </>
  );
}